module.exports = __webpack_public_path__ + "img/Ham.9a830929.jpg";